<zbp-button-component id="audioButton"
                      [ngbPopover]="popoverControl?.popoverContent"
                      popoverClass="viewer-control-popover"
                      [popperOptions]="popperOptions"
                      [autoClose]="'outside'"
                      (shown)="showPopover()"
                      (hidden)="closePopover()"
                      [placement]="isDesktop ? 'right' : 'top'"
                      container="body"
                      [openDelay]="0"
                      [closeDelay]="0"
                      [theme]="'viewerControl'"
                      [borderRadius]="'0'"
                      [label]="'audio'"
                      [ariaLabel]="'audio'"
                      [ariaExpanded]="isPopoverOpen"
                      [iconPosition]="'top'"
                      [iconName]="zbpIconNames.audioHeadphonesIcon"
                      [customClass]="'viewer-asset-control-button'"
                      #popover="ngbPopover"
/>
<zbp-audio-player #audioPlayer="AudioPlayerComponent"
                  [assetName]="assetName"
                  [audioFile]="audioFile"
                  [hidden]="true"
/>
<zbp-viewer-control-popover #popoverControl="ControlPopoverComponent"
                            title="AUDIO"
                            (shouldClosePopover)="popover.close()"
                            [hidden]="true">
  @let audio = audioPlayer?.audioElement?.nativeElement;
  @if (assets?.length && audio) {
    <div class="audio-content">
      <zbp-select
        labelForId="asset-input"
        [items]="assets"
        bindLabel="name"
        [formControl]="assetControl"
        theme="dark"
      />
      <div class="scrub-time-container">
        {{ audioPlayer.time }} / {{ audioPlayer.duration }}
      </div>
      <input class="scrub-bar"
             type="range"
             [min]="0"
             [value]="audio.currentTime"
             [step]="0.1"
             [max]="audio.duration"
             (input)="audioPlayer.updateTime($event)"
      />
      <div class="play-button-container">
        <zbp-button-component
          [iconName]="audioPlayer.icon"
          iconSize="font-size"
          theme="viewerPopoverSmall"
          borderRadius="50%"
          fontSizeUnit="em"
          (clickHandler)="audioPlayer.playOrPause()"
        />
      </div>
      <div class="speed-controls-container">
        <div>speed</div>
        <zbp-button-component
          label="0.5x"
          (clickHandler)="audioPlayer.setPlaybackSpeed(0.5)"
          [theme]="audio.playbackRate === 0.5 ? 'viewerPopoverSmallActive' : 'viewerPopoverSmall'"
        />
        <zbp-button-component
          label="0.75x"
          (clickHandler)="audioPlayer.setPlaybackSpeed(0.75)"
          [theme]="audio.playbackRate === 0.75 ? 'viewerPopoverSmallActive' : 'viewerPopoverSmall'"
        />
        <zbp-button-component
          label="1x"
          (clickHandler)="audioPlayer.setPlaybackSpeed(1)"
          [theme]="audio.playbackRate === 1 ? 'viewerPopoverSmallActive' : 'viewerPopoverSmall'"
        />
        <zbp-button-component
          label="1.25x"
          (clickHandler)="audioPlayer.setPlaybackSpeed(1.25)"
          [theme]="audio.playbackRate === 1.25 ? 'viewerPopoverSmallActive' : 'viewerPopoverSmall'"
        />
        <zbp-button-component
          label="1.5x"
          (clickHandler)="audioPlayer.setPlaybackSpeed(1.5)"
          [theme]="audio.playbackRate === 1.5 ? 'viewerPopoverSmallActive' : 'viewerPopoverSmall'"
        />
      </div>

      <!-- Separate transcript tile (always shown if transcript exists; expands in place when clicked) -->
      @if (transcript) {
        <div id="transcript-tile"
             class="transcript-tile"
             role="region"
             [attr.aria-expanded]="showTranscript"
             [attr.aria-label]="'Audio transcript ' + (showTranscript ? '(expanded)' : '(collapsed)')">
          <button
            id="transcript-trigger"
            class="transcript-trigger"
            (click)="toggleTranscript()"
            type="button"
            [attr.aria-expanded]="showTranscript"
            aria-label="transcript"
            aria-controls="transcript-content">
            <span class="transcript-trigger-text">
              <zbp-icon [iconName]="zbpIconNames.align_left"/>
              Transcript
            </span>
            @if (showTranscript) {
              <zbp-icon [iconName]="zbpIconNames.arrow_chevron_up"/>
            } @else {
              <zbp-icon [iconName]="zbpIconNames.arrow_chevron_down"/>
            }
          </button>

          <!-- Expanded content (inside the same tile, shown below button when expanded) -->
          @if (showTranscript) {
            <div
              id="transcript-content"
              class="transcript-content-area">
              <section class="transcript-section">
                <div class="transcript-text" [innerHTML]="transcript"></div>
              </section>
            </div>
          }
        </div>
      }
    </div>
  }
</zbp-viewer-control-popover>
